import React from "react";

export function StatCard({
  title,
  value,
  change,
  changeType = "neutral",
  icon,
  iconColor = "#E0F2FF", // equivalent of bg-primary/10
}) {
  // Map text color based on changeType
  const changeColorMap = {
    positive: "#16A34A", // text-success
    negative: "#DC2626", // text-destructive
    neutral: "#6B7280",  // text-muted-foreground
  };

  const styles = {
    card: {
      borderRadius: "0.5rem",
      padding: "1rem",
      backgroundColor: "#fff",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      border: "1px solid #D1D5DB", // added visible border
      display: "flex",
      flexDirection: "column",
      animation: "fade-in 0.3s ease-in-out",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
    title: {
      fontSize: "0.875rem", // text-sm
      fontWeight: 500,
      color: "#6B7280", // text-muted-foreground
      margin: 0,
    },
    value: {
      fontSize: "1.5rem", // text-2xl
      fontWeight: 700,
      color: "#111827", // text-foreground
      marginTop: "0.25rem",
      marginBottom: 0,
    },
    change: {
      fontSize: "0.875rem",
      fontWeight: 500,
      marginTop: "0.5rem",
      color: changeColorMap[changeType],
    },
    iconContainer: {
      padding: "0.75rem", // p-3
      borderRadius: "0.5rem",
      backgroundColor: iconColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  };

  return (
    <div style={styles.card}>
      <div style={styles.header}>
        <div>
          <p style={styles.title}>{title}</p>
          <p style={styles.value}>{value}</p>
          {change && <p style={styles.change}>{change}</p>}
        </div>
        <div style={styles.iconContainer}>{icon}</div>
      </div>
    </div>
  );
}
